import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { OverlayBannerBlock } from "../components/OverlayBannerBlock";

export const Template = (
    props: Immutable<templates.OverlayBannerAssemblyTemplate>,
): React.JSX.Element | null => {
    if (!props.page.overlay_banner) {
        return null;
    }
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.page.overlay_banner.value}
            components={{
                overlay_banner: (block) => (
                    <OverlayBannerBlock value={block.value} />
                ),
            }}
        />
    );
};
